<div class="search-div">
  <div style="margin-top: 15px; margin-left:40px;">
  <button mat-raised-button class="btn-color-example" (click)="onCreate()">
    <mat-icon>add</mat-icon>Add Panel Member
  </button>
  <button mat-raised-button class="btn-color-example" style="margin-left: 10px;" (click)="onUpload()"
    matTooltip="Bulk upload for panel member through csv/excel">Upload csv/excel</button>
  </div>
  <!-- <input #csvInput hidden="true" type="file" onclick="this.value=null"
        (change)="csvInputChange($event.target.files)" accept=".csv, .xls, .xlsx" />
  <button mat-flat-button color="primary" (click)="csvInput.click()" matTooltip="Bulk upload for panelMember through csv/excel">Upload csv/excel</button> -->

  <mat-form-field class="search-form-field">
    <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter" [(ngModel)]="filterName" name="filterName">
    <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)= "onClear()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>
<!-- <div class="upload-progress">
  {{percentCompleted}}% Uploaded
  <mat-progress-bar mode="determinate" value="40"></mat-progress-bar>
  <div *ngIf="isSingleUploaded" class="success">File uploaded successfully</div>
</div> -->
<!-- <div class="my-class" [ngClass]="status ? 'upload-show' : 'upload-hide'">
  <span>Only .xlsx & .xls extensions file can be acceptable </span>
</div> -->
<!-- <div class="download-templete">
  <a href="./assets/PanelMember.xlsx" class="btn clss" target="_self"
    matTooltip="Download the excel/csv format for bulk upload" 
    matTooltipPosition="above" download>Download Template</a>
</div> -->
<div  class="mat-elevation-z8" style="margin-left: 40px; margin-right: 25px;">
<mat-table mat-table [dataSource]="listData" matSort>

  <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->
  <!-- Name Column -->

  <!-- Position Column -->
  <!-- <ng-container matColumnDef="position">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Sl No. </th>
    <td mat-cell *matCellDef="let element; let i = index;"> {{i+1}} </td>
  </ng-container> -->

  <!-- Name Column -->
  <ng-container matColumnDef="panelMemberName">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
    <mat-cell  *matCellDef="let element"> {{element.panelMemberName}} </mat-cell>
  </ng-container>

  <!-- Email Column -->
  <ng-container matColumnDef="email">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Email </mat-header-cell>
    <mat-cell  *matCellDef="let element"> {{element.email}} </mat-cell>
  </ng-container>

  <!-- Contact No. Column -->
  <ng-container matColumnDef="contactNo">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Mobile </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{element.contactNo}} </mat-cell>
  </ng-container>

  <!-- Action Column -->
  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef>Action Buttons</mat-header-cell>
    <mat-cell *matCellDef="let element">
      <button mat-icon-button (click)="onEdit(element.panelMemberId)">
        <mat-icon>edit</mat-icon>
      </button>
      <!-- <button mat-icon-button color="warn" (click)="onDelete(element.panelMemberId)">
        <mat-icon>delete_outline</mat-icon>
      </button> -->
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="loading">
    <mat-footer-cell *matFooterCellDef colspan="6">
        <!-- Loading data..... -->
        No Data Available
    </mat-footer-cell>
  </ng-container>

  <ng-container matColumnDef="noData">
    <mat-footer-cell *matFooterCellDef colspan="6">
        No Data
    </mat-footer-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;" class="example-element-row"></mat-row>
  <mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':listData!=null}"></mat-footer-row>
  <mat-footer-row mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide':!(listData!=null && listData.data.length==0)}">
  </mat-footer-row>
</mat-table>
<mat-paginator [pageSizeOptions]="[5, 10, 15, 20, 25, 50, 100]" [pageSize]="10"></mat-paginator>
</div>